var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.5H13V11.5H5V14.5L0 10.5L5 6.5V9.5ZM4 16.5H6.708C7.86269 17.5183 9.28669 18.1819 10.8091 18.4109C12.3316 18.64 13.8878 18.4249 15.291 17.7915C16.6942 17.1581 17.8849 16.1332 18.7201 14.8398C19.5553 13.5465 19.9995 12.0396 19.9995 10.5C19.9995 8.96042 19.5553 7.45354 18.7201 6.16019C17.8849 4.86683 16.6942 3.84194 15.291 3.2085C13.8878 2.57506 12.3316 2.35998 10.8091 2.58906C9.28669 2.81815 7.86269 3.48167 6.708 4.5H4C4.93066 3.25718 6.13833 2.24851 7.52707 1.55414C8.91581 0.859775 10.4473 0.498836 12 0.500003C17.523 0.500003 22 4.977 22 10.5C22 16.023 17.523 20.5 12 20.5C10.4473 20.5012 8.91581 20.1402 7.52707 19.4459C6.13833 18.7515 4.93066 17.7428 4 16.5Z",
    fill: "#FA1414"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.198be2f417e44eefe0876ebcd1cb812a.svg";
export { ForwardRef as ReactComponent };